"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClaimSDK = void 0;
var ethers_1 = require("ethers");
var lodash_1 = require("lodash");
var sdk_1 = require("../base/sdk");
var DAY = 1000 * 60 * 60 * 24;
var FV_LOGIN_MSG = "Sign this message to login into GoodDollar Unique Identity service.\nWARNING: do not sign this message unless you trust the website/application requesting this signature.\nnonce:";
var FV_IDENTIFIER_MSG2 = "Sign this message to request verifying your account <account> and to create your own secret unique identifier for your anonymized record.\nYou can use this identifier in the future to delete this anonymized record.\nWARNING: do not sign this message unless you trust the website/application requesting this signature.";
var ClaimSDK = /*#__PURE__*/function (_sdk_1$BaseSDK) {
  _inherits(ClaimSDK, _sdk_1$BaseSDK);
  var _super = _createSuper(ClaimSDK);
  function ClaimSDK() {
    _classCallCheck(this, ClaimSDK);
    return _super.apply(this, arguments);
  }
  _createClass(ClaimSDK, [{
    key: "generateFVLink",
    value: function () {
      var _generateFVLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(firstName, callbackUrl) {
        var popupMode,
          chainId,
          steps,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              popupMode = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              chainId = _args.length > 3 ? _args[3] : undefined;
              steps = this.getFVLink(chainId);
              _context.next = 5;
              return steps.getFvSig();
            case 5:
              return _context.abrupt("return", steps.getLink(firstName, callbackUrl, popupMode));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function generateFVLink(_x, _x2) {
        return _generateFVLink.apply(this, arguments);
      }
      return generateFVLink;
    }()
  }, {
    key: "getFVLink",
    value: function getFVLink(chainId) {
      var loginSig, fvSig, nonce, account;
      var defaultChainId = chainId;
      var env = this.env,
        provider = this.provider;
      var signer = provider.getSigner();
      var identityUrl = env.identityUrl;
      var getLoginSig = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                nonce = (Date.now() / 1000).toFixed(0);
                _context2.next = 3;
                return signer.signMessage(FV_LOGIN_MSG + nonce);
              case 3:
                loginSig = _context2.sent;
                return _context2.abrupt("return", loginSig);
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function getLoginSig() {
          return _ref.apply(this, arguments);
        };
      }();
      var getFvSig = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return signer.getAddress();
              case 2:
                account = _context3.sent;
                _context3.next = 5;
                return signer.signMessage(FV_IDENTIFIER_MSG2.replace("<account>", account));
              case 5:
                fvSig = _context3.sent;
                return _context3.abrupt("return", fvSig);
              case 7:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function getFvSig() {
          return _ref2.apply(this, arguments);
        };
      }();
      var getLink = function getLink(firstName, callbackUrl) {
        var popupMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var chainId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultChainId;
        if (!fvSig) {
          throw new Error("missing login or identifier signature");
        }
        if (popupMode === false && !callbackUrl) {
          throw new Error("redirect url is missing for redirect mode");
        }
        var url = new URL(identityUrl);
        var searchParams = url.searchParams;
        var params = {
          account: account,
          nonce: nonce,
          fvsig: fvSig,
          firstname: firstName,
          sg: loginSig,
          chain: chainId
        };
        (0, lodash_1.forIn)(params, function (value, param) {
          if (!value) {
            return;
          }
          searchParams.append(param, String(value));
        });
        if (callbackUrl) {
          searchParams.append(popupMode ? "cbu" : "rdu", callbackUrl);
        }
        return url.toString();
      };
      return {
        getLoginSig: getLoginSig,
        getFvSig: getFvSig,
        getLink: getLink
      };
    }
  }, {
    key: "isAddressVerified",
    value: function () {
      var _isAddressVerified = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(address) {
        var identity;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              identity = this.getContract("Identity");
              return _context4.abrupt("return", identity.isWhitelisted(address));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function isAddressVerified(_x3) {
        return _isAddressVerified.apply(this, arguments);
      }
      return isAddressVerified;
    }()
  }, {
    key: "checkEntitlement",
    value: function () {
      var _checkEntitlement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(address) {
        var ubi;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              ubi = this.getContract("UBIScheme");
              _context5.prev = 1;
              if (!address) {
                _context5.next = 6;
                break;
              }
              _context5.next = 5;
              return ubi["checkEntitlement(address)"](address);
            case 5:
              return _context5.abrupt("return", _context5.sent);
            case 6:
              _context5.next = 8;
              return ubi["checkEntitlement()"]();
            case 8:
              return _context5.abrupt("return", _context5.sent);
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](1);
              return _context5.abrupt("return", ethers_1.BigNumber.from("0"));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 11]]);
      }));
      function checkEntitlement(_x4) {
        return _checkEntitlement.apply(this, arguments);
      }
      return checkEntitlement;
    }()
  }, {
    key: "getNextClaimTime",
    value: function () {
      var _getNextClaimTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var ubi, _yield$Promise$all$th, _yield$Promise$all$th2, periodStart, currentDay, startRef;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              ubi = this.getContract("UBIScheme");
              _context6.next = 3;
              return Promise.all([ubi.periodStart(), ubi.currentDay()]).then(function (values) {
                return (0, lodash_1.invokeMap)(values, "toNumber");
              });
            case 3:
              _yield$Promise$all$th = _context6.sent;
              _yield$Promise$all$th2 = _slicedToArray(_yield$Promise$all$th, 2);
              periodStart = _yield$Promise$all$th2[0];
              currentDay = _yield$Promise$all$th2[1];
              startRef = new Date(periodStart * 1000 + currentDay * DAY);
              if (startRef < new Date()) {
                startRef = new Date(startRef.getTime() + DAY);
              }
              return _context6.abrupt("return", startRef);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getNextClaimTime() {
        return _getNextClaimTime.apply(this, arguments);
      }
      return getNextClaimTime;
    }()
  }, {
    key: "claim",
    value: function () {
      var _claim = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(txOverrides) {
        var ubi;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              ubi = this.getContract("UBIScheme");
              return _context7.abrupt("return", ubi.claim(txOverrides));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function claim(_x5) {
        return _claim.apply(this, arguments);
      }
      return claim;
    }()
  }]);
  return ClaimSDK;
}(sdk_1.BaseSDK);
exports.ClaimSDK = ClaimSDK;